import ReportsService from '../services/ReportsService';

class ReportsController {
  async getHTMLReport(eventId, eventTitle = null) {
    try {
      const htmlContent = await ReportsService.getProcessedReportHTML(eventId, eventTitle);
      return {
        success: true,
        data: htmlContent
      };
    } catch (error) {
      console.error('ReportsController.getHTMLReport error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  async getJSONReport(eventId) {
    try {
      const jsonData = await ReportsService.getReportJSON(eventId);
      return {
        success: true,
        data: jsonData
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async downloadReport(eventId, format, eventTitle = null) {
    try {
      await ReportsService.downloadReport(eventId, format, eventTitle);
      return {
        success: true,
        message: `Reporte ${format.toUpperCase()} descargado exitosamente`
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
  
  async downloadReportCustom(customUrl, eventTitle, format) {
    try {
      await ReportsService.downloadReportCustom(customUrl, eventTitle, format);
      return {
        success: true,
        message: `Reporte ${format.toUpperCase()} descargado exitosamente`
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  async getValidatedEvents() {
    try {
      const events = await ReportsService.getValidatedEvents();
      return {
        success: true,
        data: events
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }




}

export default new ReportsController();